const store = {
  automationData: {
    entities: {
      automation: {},
      action: {},
      trigger: {}
    },
    result: {
      actions: {},
      automations: [],
      triggers: []
    }
  },
  appAutomationData: {
    entities: {
      automation: {},
      action: {},
      trigger: {}
    },
    result: {
      actions: {},
      automations: [],
      triggers: []
    }
  },
  collapseTriggers: {},
  currentAutomation: {
    trigger: {},
    triggerArguments: {},
    action: {},
    actionArguments: {},
    id: null,
    shared: false
  },
  automationToDelete: {
    trigger: {},
    triggerArguments: {},
    action: {},
    actionArguments: {},
    id: null,
    shared: false
  },
  emailsSynced: [],
  emailSignature: "",
  loading: true,
  saving: false,
  savingStatus: true,
  editing: false,
  deleting: false,
  shareSelection: false,
  defaultList: {
    name: "",
    description: "",
    listId: "",
    address: {
      company: "",
      city: "",
      line1: "",
      line2: "",
      "postal-code": "",
      province: "",
      "street-direction": "",
      "street-name": "",
      "street-number": "",
      "unit-number": ""
    }
  },
  defaultMarketingEmail: {
    emailId: "",
    email: "",
    verified: null,
    updatedAt: ""
  },
  changingAutomationStatus: false,
  documentRequestAutomations: {
    byId: {},
    allIds: []
  },
  documentRequestAutomationSchema: {
    byId: {},
    allIds: []
  },
  documentRequestEditMode: {},
  automationsDataLoaded: false
};
export default store;